import { render, staticRenderFns } from "./PlanTrailers.vue?vue&type=template&id=653f6b86&scoped=true&"
import script from "./PlanTrailers.vue?vue&type=script&lang=js&"
export * from "./PlanTrailers.vue?vue&type=script&lang=js&"
import style0 from "./PlanTrailers.vue?vue&type=style&index=0&id=653f6b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f6b86",
  null
  
)

export default component.exports